import { limitCharacters } from '../../util/textUtil.ts';
import { cardDescriptionCharacterLimit } from './constants.ts';
import { cardTitleCharacterLimit } from './constants.ts';
import { getCardImage, getCardImageClasses, getCardImageContainerClasses, getCardTags } from './previewCardPropsUtils.ts';
export const mapPopulatedContentToCards = (populatedBlock) => {
    if (!populatedBlock) {
        return [];
    }
    const contentItems = populatedBlock.overrideArea?.expandedValue || [];
    const mappedCards = contentItems
        .filter(isContentDetailPage)
        .map((item) => mapPopulatedContentToCard(item, populatedBlock));
    return mappedCards;
};
const mapPopulatedContentToCard = (cdp, populatedResourcePreviewCardsBlock) => {
    return {
        href: cdp.contentLink?.url || '',
        title: cdp.heading?.value
            ? limitCharacters(cdp.heading.value, cardTitleCharacterLimit, '...')
            : '',
        description: cdp.teaserText?.value
            ? limitCharacters(cdp.teaserText.value, cardDescriptionCharacterLimit, '...')
            : '',
        cardBgColor: populatedResourcePreviewCardsBlock.cardBackgroundColor?.value,
        image: getCardImage(cdp, populatedResourcePreviewCardsBlock.cardVariant?.value),
        imageClasses: getCardImageClasses(cdp, populatedResourcePreviewCardsBlock.cardVariant?.value),
        imageContainerClasses: getCardImageContainerClasses(cdp, populatedResourcePreviewCardsBlock.cardVariant?.value, populatedResourcePreviewCardsBlock.cardImageBackgroundColor?.value),
        tags: getCardTags(cdp, populatedResourcePreviewCardsBlock.cardVariant?.value),
        titleEyebrow: cdp.referenceContentType?.value || ''
    };
};
export const isContentDetailPage = (page) => {
    return page.contentType[1] === 'ContentDetailPage';
};
